import Cookies from 'js-cookie';
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";
import API_CLS from "@/utils/api.ts";




const eCreditFetch = async (endpoint:string, options?: any, retryAttempt = false) => {
    let csrf_token = Cookies.get('ec_csrf');
    let defaultOptions = {
        method: options.method,
        headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
        },
        credentials: 'include',
        ...options,
    };

    if (options.body) {
        defaultOptions.body = options.body;
    }
    if (options.headers) {
        // TODO: aici e problema de merging!!! trebuie de rezolvat!
        defaultOptions.headers = { ...defaultOptions.headers, ...options.headers };
    }

    if (!csrf_token) {
        const request = await fetch(import.meta.env.VITE_API_URL + "/api/web/client/csrf/refresh", {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache',
            },
            credentials: 'include',
        });

        if (request.status === 200) {
            csrf_token = Cookies.get('ec_csrf');
        }
    }
    if (csrf_token) {
        defaultOptions.headers["X-CSRF-Token"] = csrf_token;

    }

    // TODO: de scos acest  header si sa fie preluat din options
    if (defaultOptions.headers && Object.prototype.hasOwnProperty.call(defaultOptions.headers, "X-ReCaptcha-Token")) {
        defaultOptions.headers["Content-Type"] = "application/json";
    }

    try {
        const response = await fetch(import.meta.env.VITE_API_URL + endpoint, defaultOptions);
        // GET TIME
        const clientTime = new Date();
        const serverDateHeader = response?.headers.get("Date");
        const serverTime = serverDateHeader ? new Date(serverDateHeader) : null;


        if (serverTime) {

            const timeDiff = Math.abs(clientTime.getTime() - serverTime.getTime());

            const fiveMinutes = 5 * 60 * 1000;

            if (timeDiff > fiveMinutes) {
                eventEmitter.emit(CommonClass.CustomEvents.server_time_not_good, true);
            }
        } else {
            console.error("Server Time: Not available in headers");
        }
        // GET TIME END
        const responseClone = response.clone();
        const responseBody = await responseClone.text();
        const contentType = response.headers.get("content-type");
        
        if (contentType?.includes("application/pdf")) {
            return response;
        }
        
        if (JSON.parse(responseBody)?.message === "invalid csrf token") {
            if (!retryAttempt) {
                return eCreditFetch(endpoint, options, true);
            }
        }
        
        if ([401, 403].includes(responseClone.status)) {
            eventEmitter.emit(CommonClass.CustomEvents.session_expired, true);
            eventEmitter.emit(CommonClass.CustomEvents.clear_states);
            console.error("TOKEN EXPIRED");
        }

        if (responseClone.status === 200 && responseClone.url.includes(API_CLS.account.me)) {
            eventEmitter.emit(CommonClass.CustomEvents.session_expired, false);
            eventEmitter.emit(CommonClass.CustomEvents.reset_counter);
            
        }

        return response;
    } catch (error) {
        console.error("An error occurred during the fetch operation:", error);
        eventEmitter.emit(CommonClass.CustomEvents.no_connection_listener_show, true);
        throw error;
    }
};

export default eCreditFetch;
